import { render, staticRenderFns } from "./examinationVisualAcuityHome.vue?vue&type=template&id=83c19fa0&scoped=true&"
import script from "./examinationVisualAcuityHome.vue?vue&type=script&lang=js&"
export * from "./examinationVisualAcuityHome.vue?vue&type=script&lang=js&"
import style0 from "./examinationVisualAcuityHome.vue?vue&type=style&index=0&id=83c19fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c19fa0",
  null
  
)

export default component.exports